<ng-template #legend>
  <div class="legends">
    <div class="legend" *ngFor="let legend of legends">
      <h3>{{ legend.title }}</h3>
      <div *ngFor="let legendItem of legend.legendItems" class="mb-1" [ngClass]="{ line: legendItem.showLine }">
        <span class="legend-color me-1" [style.background-color]="legendItem.color" [ngClass]="{ line: legendItem.showLine }"></span>
        {{ legendItem.label }}
        <span *ngIf="legendItem.value !== undefined && legendItem.showCount">({{ legendItem.value }})</span>
      </div>
    </div>
  </div>
</ng-template>

<button type="button" class="text-info legend-hover" *ngIf="legends && legends.length > 0">
  <i class="far fa-question-circle" [ngbTooltip]="legend" placement="left right" container="body" tooltipClass="legend-tooltip"></i>
</button>
